import React, {useEffect} from 'react';
import {Box, Stack} from "@mui/material";
import {IVoceCosto} from "../../../../../../utils/interfaces/tannery_production/order_schedule/schede_costo/IVoceCosto";
import useApiCreateVoceCosto from "./api-hooks/useApiCreateVoceCosto";
import useApiUpdateVoceCosto from "./api-hooks/useApiUpdateVoceCosto";
import useApiGetVoceCostoDetail from "./api-hooks/useApiGetVoceCostoDetail";
import {useToast} from "../../../../../../utils/contexts/toast-context";
import {useQueryClient} from "@tanstack/react-query";
import {Controller, useForm} from "react-hook-form";
import MuiInputTextField from "../../../../../ui/mui/mui-input/MuiInputTextField";
import SaveOrBackForm from "../../../../../ui/common_components/SaveOrBackForm";
import MuiCheckboxComponent from "../../../../../ui/mui/mui-input/MuiCheckBox";


interface Props {
    objToEdit: IVoceCosto | null | undefined;
    onClose: () => void;
    onSelect?: (obj: IVoceCosto | undefined) => void,
}

const VociCostoForm: React.FC<Props> = ({objToEdit, onClose, onSelect}) => {
    const {displayMessage, displayError} = useToast();
    const queryClient = useQueryClient();
    const {control, handleSubmit, setValue} = useForm<IVoceCosto>({});

    const createMutation = useApiCreateVoceCosto();
    const updateMutation = useApiUpdateVoceCosto();

    const [isActive, setIsActive] = React.useState(false);

    const {
        data: detailedObj,
    } = useApiGetVoceCostoDetail(objToEdit?.id);

    useEffect(() => {
        if (detailedObj) {
            Object.entries(detailedObj).forEach(([key, value]) => {
                setValue(key as keyof IVoceCosto, value);
            });
        }
        setIsActive(detailedObj?.is_active || false);
    }, [detailedObj, setValue]);

    const onSubmit = async (formData: IVoceCosto) => {
        const mutation_data = {
            ...formData,
            is_active: isActive,
        };

        try {
            if (detailedObj) {
                await updateMutation.mutateAsync({
                    id: detailedObj.id,
                    data: mutation_data
                });
                await queryClient.invalidateQueries({queryKey: ["useApiGetVoceCostoDetail", detailedObj.id]});
                displayMessage('updated successfully');
            } else {
                await createMutation.mutateAsync(mutation_data);
                displayMessage('added successfully');
            }
            onClose();
            await queryClient.invalidateQueries({queryKey: ['useApiGetVociCosto']});
        } catch (error) {
        }
    };


    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{padding: 2, minWidth: 400}}>

                <Stack direction={{xs: "column", md: "row"}} spacing={2}>
                    <Box flex={1}>
                        <Controller
                            name="row_position"
                            control={control}
                            render={({field}) => (
                                <MuiInputTextField
                                    label="posizione"
                                    type="number"
                                    {...field}
                                />
                            )}
                        />
                    </Box>
                    <Box flex={1}>
                        <Controller
                            name="name"
                            control={control}
                            render={({field}) => (
                                <MuiInputTextField
                                    label="Nome"
                                    type="text"
                                    {...field}
                                />
                            )}
                        />
                    </Box>

                </Stack>

                <Stack direction={{xs: "column", md: "row"}} spacing={2}>
                    <Box flex={1}>
                        <Controller
                            name="um_coefficient"
                            control={control}
                            render={({field}) => (
                                <MuiInputTextField
                                    label="um (mq, pz)"
                                    type="text"
                                    {...field}
                                />
                            )}
                        />
                    </Box>
                    <Box flex={1}>
                        <MuiCheckboxComponent
                            isFilter={false}
                            key={'isActive'}
                            label={('da inserire alla creazione della scheda')}
                            checked={!!isActive}
                            onChange={() => setIsActive(!isActive)}
                        />

                    </Box>
                </Stack>


                <Stack spacing={2}>
                    <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1}}>
                        <SaveOrBackForm
                            onSubmit={onSubmit}
                            onClose={onClose}
                            handleSubmit={handleSubmit}
                        />
                    </Box>

                </Stack>
            </Box>


        </form>
    );
};

export default VociCostoForm;